const VideoBase = `api/vertex-adapter/video`;
const ImageBase = `api/vertex-adapter/image`;
const TTSBase = `api/vertex-adapter/tts`;
const LLMBase = `api/vertex-adapter/llm`;

export const VertexRoutes = {
  tts: {
    listVoices: `${TTSBase}/list`,
    synthesize: `${TTSBase}/synthesize`,
  },
  image: {
    generate: `${ImageBase}/generate`,
  },
  video: {
    generate: `${VideoBase}/generate`,
  },
  llm: {
    generate: `${LLMBase}/generate`,
  },
};
